import React, { useEffect, useState } from 'react';
import { backToStartAction } from 'ouisys-engine/moFlow';
import { tracker } from 'ouisys-engine/utilities/tracker';
import { IKeywordShortcode, MOLink, Link } from 'ouisys-component-library';
import { injectIntl, FormattedMessage } from '../../localization/index';
import { useDispatch } from '../../__doNotModify/store';
import { useRootContext } from '../../providers/RootContext';
import './MO.scss';
import { checkSubscriptionHander } from 'ouisys-engine/utilities/checkSubscriptionHander';

const MO = ({ keyword, shortcode }: IKeywordShortcode) => {
  const dispatch = useDispatch();
  const backToStart = () => dispatch(backToStartAction());
  const { setIsMoView } = useRootContext();
  const [mobileClicked, setMobileClicked] = useState(false);

  useEffect(() => {
    setIsMoView(true);
  }, []);

  return (
    <div className="MO">
      {/* mo mobile */}
      <div className="MO_views mobile">
        {mobileClicked ? (
          <MOLink
            id="MO_link_second"
            className="MO_views_link"
            onClick={() => {
              checkSubscriptionHander({
                window,
                flow: 'mo',
                action: 'user-revist',
                args: { keyword, shortcode }
              });
            }}
            keywordAndShortcode={{ keyword, shortcode }}
          >
            <h3 className="waiting">
              <FormattedMessage id="moRequestWaiting" defaultMessage="Waiting for your response..." />
            </h3>
            <div className="label">
              <FormattedMessage
                id="moRequestMessage"
                defaultMessage="If you did not receive the download link via SMS, please click the button below:"
              />
            </div>
            <div className="btn" id="retryMoButton">
              <FormattedMessage id="moRequestButton" defaultMessage="Request again!" />
            </div>
          </MOLink>
        ) : (
          <MOLink
            id="MO_link_first"
            className="MO_views_link"
            onClick={() => {
              checkSubscriptionHander({
                window,
                flow: 'mo',
                action: 'click',
                args: { keyword, shortcode }
              });
              setMobileClicked(true);
            }}
            keywordAndShortcode={{ keyword, shortcode }}
          >
            <div className="label">
              <FormattedMessage
                id="moTitle"
                defaultMessage="Please verify your mobile number by pressing the button below to continue downloading your file."
              />
            </div>
            <div className="btn">
              <FormattedMessage id="moButton" defaultMessage="Verify via SMS" />
            </div>
            <div className="moInstructions">
              <p>
                <FormattedMessage id="moLabelSend" defaultMessage="Send" /> <b>{keyword}</b>{' '}
                <FormattedMessage id="moLabelTo" defaultMessage="to" /> <b>{shortcode}</b>
              </p>
            </div>
          </MOLink>
        )}

        <a className="tryAgainLink" onClick={backToStart}>
          <FormattedMessage id="tryAgainLabel" defaultMessage="Try again" />
        </a>
      </div>

      {/* mo dekstop */}
      <div className="MO_views desktop" onLoad={() => console.log('desktop')}>
        <div className="label">
          <FormattedMessage
            id="moTitleDesktop"
            defaultMessage="Please follow the instruction below to continue downloading your file."
          />
        </div>
        <span className="MO_label">
          <FormattedMessage id="moLabelSend" defaultMessage="Send" />
        </span>
        <span className="MO_keys">{keyword}</span>
        <span className="MO_label">
          <FormattedMessage id="moLabelTo" defaultMessage="to" />
        </span>
        <span className="MO_keys">{shortcode}</span>
      </div>
    </div>
  );
};

export default injectIntl(MO);
